module.exports = __webpack_public_path__ + "static/img/Woman SLG.b1e93d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Woman SLG.jpg
// module id = eKID
// module chunks = 1